import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './NoTasks.m.sass';

// Since this component has no props, we can create it once.
var element = /*#__PURE__*/React.createElement("div", {
  className: cx(styles.root)
}, /*#__PURE__*/React.createElement("div", {
  className: styles.content
}, /*#__PURE__*/React.createElement("p", {
  className: styles.title
}, "All Done!"), /*#__PURE__*/React.createElement("p", {
  className: styles.description
}, "You have no tasks to complete for this milestone.")));
var NoTasks = function NoTasks() {
  return element;
};
export default observer(NoTasks);
//# sourceMappingURL=index.js.map
